import React from 'react';
import './Profile.scss';
import picture from '../../img/profileImg.png';
import { profileData } from '../Cards/Data/Data';
import { Link } from 'react-router-dom';
import DownloadRoundBtn from '../../CV/DownloadRoundBtn';
import ProfileName from './ProfileName';
import { openInNewTab } from '../../utils/openInNewTab';

function Profile() {
  return (
    <div className='profile'>
      <img className='profile-picture' src={picture} alt='Nedeljko Popović' />
      <ProfileName />
      <div className='profile-links'>
        <ul className='profile-links--list'>
          {profileData.map((link) => (
            <li key={link.id} className='profile-link'>
              <Link
                className='icon-container'
                aria-label={link.name}
                onClick={() => openInNewTab(link.href)}
              >
                <span className='inner'></span>
                {link.icon}
              </Link>
            </li>
          ))}
          <DownloadRoundBtn />
        </ul>
      </div>
    </div>
  );
}

export default Profile;
